import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=b5c68fb0&"
import script from "./StatisticsView.vue?vue&type=script&lang=js&"
export * from "./StatisticsView.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=b5c68fb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports